import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import { EVENT_GET_DETAIL_BOT_LOG } from '../../configs/EventTypes';
import {ReportPDFScreen} from '../../screens';

import CustomDialog from '../../components/Notifications/Dialog';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

var base64 = require('base-64');
var utf8 = require('utf8');

const initial_hamberger_status = {
    aria_expanded: false,
    class: 'collapsed',
    collapsed: 'collapse',
};

class ReportTablePage extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            searchResult:[],
            page:0,
            rowsPerPage: 10,
            hamberger_status: initial_hamberger_status,
            openPrintFile: false,
            statusCode: ''
            
        }
        this.handlerClick=this.handlerClick.bind(this);
        this._toggleHambergerBar = this._toggleHambergerBar.bind(this);
        this.handlerEditClick=this.handlerEditClick.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tablesearch !== this.state.searchResult) {

            this.setState({
                searchResult: nextProps.tablesearch,
                page:0
            })
        }
    }

     handleChangePage(event, newPage, pageName) {
        this.setState({
            [pageName]: newPage
        })
    }

    handleChangeRowsPerPage(event, pageName, rowsPerPageName) {
        this.setState({
            [rowsPerPageName]: +event.target.value,
            [pageName]: 0
        })
    }

    _toggleHambergerBar() {
        let status = {};
        if (this.state.hamberger_status !== initial_hamberger_status)// กรณีโชว์อยู่
        {
            status = initial_hamberger_status;
        } else// กรณีไม่โชว์อยู่
        {
            status = {
                aria_expanded: true,
                class: '',
                collapsed: 'collapse show',
            };
        }

        this.setState({
            hamberger_status: status,
        });
    }

    setDetailBotLogModal(type, transaction_no = "") {
      
        window.emitter.emit(EVENT_GET_DETAIL_BOT_LOG, {
            transaction_no: transaction_no
        })

        window.$('#DetailBotLogModal').modal('show');

       
    }

    handleOnClosePrintFile()
    {
        this.setState({
            openPrintFile: false,
        })
    }

    setHasPrintHeader()
    {
        this.setState({
            openPrintFile: false,
            
        })

        let { onPrintHasHeader } = this.props;

        if(onPrintHasHeader)
        {
            onPrintHasHeader(this.state.transactioN_NO,this.state.statusCode,this.state.moM_DOC_NO)
        }
    }

    setNonePrintHeader()
    {
        this.setState({
            openPrintFile: false,
        })

        let { onPrintNoneHeader } = this.props;

        if(onPrintNoneHeader)
        {
            onPrintNoneHeader(this.state.transactioN_NO,this.state.statusCode,this.state.moM_DOC_NO)
        }
    }

    async handlerClick(completeD_DATE, headeR_TEXT, moM_DOC_NO, pO_CONTRACT_NO, pO_DATE, requisitioner, vendoR_NAME, rrS_DOC_NO, penaltY_AMOUNT, installmenT_NO_MR, moM_DATE,transactioN_NO,statusCode) {
        this.setState({
            completeD_DATE : completeD_DATE,
            headeR_TEXT : headeR_TEXT,
            moM_DOC_NO : moM_DOC_NO,
            pO_CONTRACT_NO : pO_CONTRACT_NO,
            pO_DATE : pO_DATE,
            requisitioner : requisitioner,
            vendoR_NAME : vendoR_NAME,
            rrS_DOC_NO : rrS_DOC_NO,
            penaltY_AMOUNT : penaltY_AMOUNT,
            installmenT_NO_MR : installmenT_NO_MR,
            moM_DATE : moM_DATE,
            transactioN_NO : transactioN_NO,
            statusCode: statusCode
        })

      
        this.setState({
            openPrintFile: true
        })
        //window.$('#pdfModal').modal('show');
    }

    handlerEditClick(rowIndex, transactionNo,doc_type,pO_CONTRACT_NO) {

        //console.log(rowIndex)
        //console.log(transaction_no)
        //console.log(doc_type)
        
        //var text = 'foo © bar 𝌆 baz';
        //var bytes = utf8.encode(text);
        //var encoded = base64.encode(bytes);

        //console.log('base64')
        //console.log(encoded);

        //var bytes = base64.decode(encoded);
        //var text = utf8.decode(bytes);
        //console.log(text);

        let { history, tasks } = this.props;

        if (transactionNo !== '') {
            //var clickRowOntask = tasks.filter((data) => {
            //    console.log("222");
            //    return data.transaction_no && data.transaction_no === transactionNo
            //})
            //if (clickRowOntask.length > 0) {
                let bytes_tran_no = utf8.encode(transactionNo);
                let encoded_transaction_no = base64.encode(bytes_tran_no);

                let bytes_po_contract_no = utf8.encode(pO_CONTRACT_NO);
                let encoded_po_contract_no = base64.encode(bytes_po_contract_no);
                if (doc_type == "BOT"){
                    history.push({
                        pathname: '/main',
                        search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                        state: { mode: 'EDIT' }
                    });
                }else{
                    history.push({
                        pathname: '/mainnotbot',
                        search: `?mode=EDIT&transaction_no=${encoded_transaction_no}&po_no=${encoded_po_contract_no}`,
                        state: { mode: 'EDIT' }
                    });
                
                }
            //}
        }
    }

    render() {

        const { searchResult, page, rowsPerPage } = this.state
        const {isAdmin} = this.props
        console.log("searchResult : ",searchResult)
        return (
            <Paper style={{display: 'flex', flex: '1'}}>
                <div className="row no-gutters sp-table-content " style={{ minWidth: '960px' }} >
                    <Table className="sp-table table rrs-table" >
                        <TableHead>
                            <TableRow className="sp-table-header">
                                <TableCell className="th-table text-center" style={{ width: '70px' }} >PO/Contract No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '70px' }} >MOM Doc No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '70px' }} >RRS Doc No.</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '310px' }} >Header Text</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '190px' }} >Create By</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '70px' }} >Create Date</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '80px' }} >Status</TableCell>
                                <TableCell className="th-table text-center" style={{ width: '100px' }} >Action</TableCell>
                                </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                searchResult ? (
                                    searchResult.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((task, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <TableCell className="text-center" >{task.pO_CONTRACT_NO}</TableCell>
                                                    <TableCell className="text-center" >{task.moM_DOC_NO}</TableCell>
                                                    <TableCell className="text-center" >{task.rrS_DOC_NO}</TableCell>
                                                    <TableCell className="text-left" >{task.headeR_TEXT}</TableCell>
                                                    <TableCell className="text-left" >{task.creatE_BY}</TableCell>
                                                    <TableCell className="text-center" >{task.creatE_DATE}</TableCell>
                                                    <TableCell className="text-left" >{task.statuS_TEXT}</TableCell>
                                                    <TableCell className="text-center" ><a onClick={() => this.handlerEditClick(index, task.transactioN_NO, task.doC_TYPE, task.pO_CONTRACT_NO) } style={{ cursor: 'pointer' }}><i className="icon icon-preview-eye-blue" /></a>&nbsp;&nbsp;&nbsp;
                                                    <a onClick={()=>this.handlerClick(task.completeD_DATE 
                                                        , task.headeR_TEXT 
                                                        , task.moM_DOC_NO 
                                                        , task.pO_CONTRACT_NO
                                                        , task.pO_DATE
                                                        , task.requisitioner
                                                        , task.vendoR_NAME
                                                        , task.rrS_DOC_NO
                                                        , task.penaltY_AMOUNT
                                                        , task.installmenT_NO_MR
                                                        , task.moM_DATE
                                                        ,task.transactioN_NO
                                                        ,task.statuS_CODE)} style={ { cursor: 'pointer', marginLeft: 5 } }><i className="icon icon-preview-pdf"></i></a>
                                                    </TableCell>                                                    
                                                
                                                </TableRow>
                                            );
                                        })) : (
                                        <TableRow key={0}>
                                            <TableCell colSpan="11" className="text-center" style={{
                                                textAlign: 'center',
                                                fontStyle: 'italic',
                                                color: 'gray'
                                            }}>No data</TableCell>
                                        </TableRow>
                                    )
                            }
                            
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={searchResult.length}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={(event, newPage) => this.handleChangePage(event, newPage, "page")}
                        onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event, "page", "rowsPerPage")}
                    />



                <div style={{display: 'none'}} id="page-pdf">
                    <ReportPDFScreen 
                        completeD_DATE = {this.state.completeD_DATE} 
                        headeR_TEXT = {this.state.headeR_TEXT} 
                        moM_DOC_NO = {this.state.moM_DOC_NO} 
                        pO_CONTRACT_NO ={this.state.pO_CONTRACT_NO}
                        pO_DATE ={this.state.pO_DATE}
                        requisitioner ={this.state.requisitioner}
                        vendoR_NAME ={this.state.vendoR_NAME}
                        rrS_DOC_NO ={this.state.rrS_DOC_NO}
                        penaltY_AMOUNT ={this.state.penaltY_AMOUNT}
                        installmenT_NO_MR ={this.state.installmenT_NO_MR}
                        moM_DATE ={this.state.moM_DATE}
                    />
                </div>

                <CustomDialog open={this.state.openPrintFile} title={"Print ใบตรวจรับการจัดซื้อ/จัดจ้าง"} maxWidth="sm"
                onClose={()=>{
                    this.handleOnClosePrintFile(false)
                }}
                >
                    
                    <Grid container  style={{marginTop:20}}
                        justifyContent="center"
                        alignItems="center">
                        <Grid item xs={12} style={{textAlign:'center'}}>
                            <FormControl>
                                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" spacing={2}>
                                <Button color="primary" variant={"contained"} onClick={()=>{this.setHasPrintHeader()}} style={{marginRight:5}} size="large">แบบมี Header/Footer</Button>
                                <Button color="primary" variant={"contained"} onClick={()=>{this.setNonePrintHeader()}} size="large">แบบไม่มี Header/Footer</Button>
                                </RadioGroup>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <p>&nbsp;</p>
                        </Grid>
                    </Grid>
                </CustomDialog>
            </div>
            </Paper>
        );

    }


}
export default ReportTablePage
